<!--
 * @LastEditors: 八千
 -->
<template>
  <div>
    <div class="container1920sub footerlist" style="background-color: #eeeeee">
      <!-- PC端图标 -->
      <div class="row relative hide-on-mobile">
        <div class="absolute gzwm" style="top: 20px">
          <p class="ab1"></p>
          <p class="clearfix weixinicon">
            <img
              class="fn-right"
              style="cursor: pointer"
              src="./weixinicon.png"
              alt
            />
          </p>
          <p class="ab2"></p>
          <p class="clearfix weiboicon">
            <a
              href="https://m.weibo.cn/u/3865917418?jumpfrom=weibocom"
              target="_blank"
            >
              <img class="fn-right" src="./weiboicon.png" alt />
            </a>
          </p>
          <p class="ab3"></p>
          <img class="qr" src="./weixincode.png" style="top: -190px" />
          <img class="qr2_old" src="./weibocode.png" style="display: none" />
        </div>
      </div>
      <!-- PC端链接 -->
      <div class="row foot-mobile hide-on-mobile">
        <div class="one fourth two-up-mobile">
          <ul>
            <li>
              <a
                href="https://www.csvw.com/csvw-website/module/index.html"
                target="_blank"
                >SAIC Volkswagen Website</a
              >
            </li>
            <li>
              <a
                href="https://www.saicmotor.com/english/index.shtml"
                target="_blank"
                >SAIC Website</a
              >
            </li>
            <li>
              <a
                href="https://www.volkswagengroupchina.com.cn/en/content/vgc/content/zh/homepage.html"
                target="_blank"
                >Volkswagen Group (China) Website</a
              >
            </li>
          </ul>
        </div>
        <div class="one fourth two-up-mobile">
          <ul>
            <li>
              <a href="https://www.svw-volkswagen.com/" target="_blank"
                >VW Brand Official Website</a
              >
            </li>
            <li>
              <a href="https://www.saic-audi.cn/" target="_blank"
                >Audi Brand Official Website</a
              >
            </li>
            <li>
              <a href="https://www.saicskoda.com.cn/" target="_blank"
                >Skoda Brand Official Website</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- 移动端链接 -->
      <div class="row foot-mobile hide-on-desktop">
        <div class="one fourth two-up-mobile">
          <a href="https://www.csvw.com/csvw-website/module/index.html">
            SAIC Volkswagen Website
          </a>
          <span>></span>
          <a href="https://www.saicmotor.com/english/index.shtml">
            SAIC Website
          </a>
          <span>></span>
        </div>
        <div class="one fourth two-up-mobile">
          <a
            href="https://www.volkswagengroupchina.com.cn/en/content/vgc/content/zh/homepage.html"
          >
            Volkswagen Group (China) Website
          </a>
          <span>></span>
        </div>
        <div class="one fourth two-up-mobile">
          <a href="https://www.svw-volkswagen.com/">
            VW Brand Official Website
          </a>
          <span>></span>
          <a href="https://www.saic-audi.cn/"> Audi Brand Official Website </a>
          <span>></span>
        </div>
        <div class="one fourth two-up-mobile">
          <a href="https://www.saicskoda.com.cn/">
            Skoda Brand Official Website
          </a>
          <span>></span>
        </div>
      </div>
      <!-- 移动端图标 -->
      <div class="row relative hide-on-desktop">
        <div class="">
          <p class="clearfix weixinicon">
            <img
              class="fn-right"
              style="cursor: pointer"
              src="./weixinicon.png"
              alt
            />
          </p>
          <p class="clearfix weiboicon">
            <a
              href="https://m.weibo.cn/u/3865917418?jumpfrom=weibocom"
              target="_blank"
            >
              <img src="./weiboicon.png" alt />
            </a>
          </p>
          <img
            class="qr"
            src="./weixincode.png"
            style="display: none; top: -190px"
          />
          <img class="qr2_old" src="./weibocode.png" style="display: none" />
        </div>
      </div>
    </div>
    <!-- 公共部分 -->
    <div class="container1920sub footinfo">
      <div class="row">
        <div
          class="one half one-up-mobile"
          style="width: 100%; text-align: center"
        >
          <div class="p1">
            Legal Statement © All rights reserved by SAIC VOLKSWAGEN Co.,Ltd
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >沪ICP备15002176号-1</a
            >
          </div>
          <div class="p2">
            <img src="./jinghuiicon.png" class="inline-block" />
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402001355"
              target="_blank"
              >沪公网安备 31011402001355 号</a
            >
          </div>
        </div>
        <div class="one half one-up-mobile" style="width: 20%; float: right">
          <div class="p3"></div>
        </div>
      </div>
    </div>
    <img
      src="../assets/images/backTop.png"
      id="backTop"
      v-show="isMobie && top"
      @click="backTop"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobie: false,
      top: false,
      showFlag0: false,
      showFlag1: false,
      showFlag2: false,
      showFlag3: false,
      showFlag4: false,
    };
  },
  beforeMount() {},
  mounted() {
    $(".weixinicon").hover(
      function () {
        $(".qr").show();
      },
      function () {
        $(".qr").hide();
      }
    );
    window.addEventListener("scroll", this.handleScroll);
    this.checkBrowser();
  },
  methods: {
    handleScroll() {
      //改变元素#searchBar的top值
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 420) {
        this.top = true;
      } else {
        this.top = false;
      }
    },
    checkBrowser() {
      var userAgent = navigator.userAgent;
      var os = {};
      os.android =
        userAgent.match(/(Android)\s+([\d.]+)/) ||
        userAgent.match(/Silk-Accelerated/)
          ? true
          : false;
      os.androidICS =
        os.android && userAgent.match(/(Android)\s4/) ? true : false;
      os.ipad = userAgent.match(/(iPad).*OS\s([\d_]+)/) ? true : false;
      os.iphone =
        !os.ipad && userAgent.match(/(iPhone\sOS)\s([\d_]+)/) ? true : false;
      os.ios = os.ipad || os.iphone;
      os.wp =
        userAgent.match(/Windows Phone/) || userAgent.match(/IEMobile/)
          ? true
          : false;
      os.supportsTouch =
        (window.DocumentTouch && document instanceof window.DocumentTouch) ||
        "ontouchstart" in window;
      os.lessIE10 = document.all && !window.atob; //Internet Explorer ≤ 9
      os.lessIE9 = document.all && !document.addEventListener; //Internet Explorer ≤ 8
      os.isWeixin =
        userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
      var isMobie = os.android || os.iphone || os.wp;
      this.isMobie = isMobie;
    },
    backTop() {
      $("html,body").animate({ scrollTop: "0px" }, "slow");
    },
    show(id) {
      let ulId = "";
      for (let i = 0; i < 5; i++) {
        ulId = "showFlag" + i;
        if (id == i) {
          this[ulId] = !this[ulId];
        } else {
          this[ulId] = false;
        }
      }
    },
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped src="../assets/less/about.css"></style>
<style scoped src="../assets/less/groundwork.css"></style>
<style scoped src="../assets/less/main.css"></style>
<style scoped src="../assets/less/swiper.min.css"></style>
<style lang="less" scoped>
#backTop {
  display: block;
  width: 55px;
  height: 55px;
  position: fixed;
  bottom: 30px;
  right: 10px;
  z-index: 100;
}

.weixinicon ~ .qr {
  display: none;
}

.weixinicon:hover ~ .qr {
  display: block;
}

.mweixin ~ .qrm {
  display: none;
}

.mweixin:hover ~ .qrm {
  display: block;
}

@media (max-width: 480px) {
  .footerlist {
    overflow: inherit;
  }
  .p1 {
    a {
      display: block;
    }
  }
  .foot-mobile ul {
    max-height: 50px;
    overflow: hidden;
    transition: max-height 0.3s linear;
  }
  .foot-mobile ul li {
    &:first-child {
      height: auto;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 12px;
        height: 6px;
        background: url("../assets/images/arrow.png") no-repeat;
        background-size: 12px 6px;
        position: absolute;
        right: 15px;
        top: 50%;
        margin-top: -3px;
        transition: all 0.3s ease-out;
      }
    }
  }
  .foot-mobile ul.active {
    max-height: 300px;
    transition: max-height 0.3s linear;
    padding-bottom: 10px;
    li {
      height: auto;
    }
    li:first-child::after {
      transform: rotate(180deg);
    }
  }
  .foot-mobile .focusMe {
    max-height: 200px;
    padding-bottom: 20px;
    li {
      height: auto;
    }
    li:first-child::after {
      display: none;
    }
  }
  .lm_foot {
    margin-top: 20px !important;
    margin-bottom: 15px;
  }
}

// 移动端样式
.hide-on-desktop {
  .two-up-mobile {
    text-align: center;
    height: 40px;
    line-height: 40px;
    a {
      font-size: 12px;
      color: #2b2b2b;
    }
    span {
      padding: 0px 3px;
    }
  }

  .weixinicon {
    width: 40%;
    clear: none;
    float: left;
    margin: 20px 0px;
  }
  .weiboicon {
    width: 40%;
    clear: none;
    float: right;
    margin: 20px 0px;
  }
  .qr {
    left: 0;
  }
}
</style>